
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class RequestDialog extends Vue {
  @Prop({ type: Boolean, default: false }) dialog!: boolean;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) success!: boolean;
  @Prop({ type: Boolean, default: false }) error!: boolean;
  @Prop({ type: String, default: 'Cargando' }) title!: string;
  @Prop({ type: String, default: '' }) errorDescription!: string;
  @Prop({ type: String, default: '' }) successMessage!: string;
  @Prop({ type: String, default: 'mdi-check-circle' }) successIcon!: string;
  @Prop({ type: String, default: 'mdi-alert' }) errorIcon!: string;
  
  get iconName() {
    return this.success ? this.successIcon : this.errorIcon;
  }
  
  get showIcon() {
    return this.success || this.error;
  }
  
  get iconColor() {
    return this.success ? 'success' : 'error';
  }

  @Emit('close')
  handleClose() {
    return false; 
  }
}
